import React, { Component } from 'react';
import ConversationOverview from '../../../../components/ConversationOverview';
import { Route, Switch, Redirect } from 'react-router';

/**
 * Conversations screen, for showing list of conversations, and selected
 * conversation.
 *
 * @extends React.Component
 */
class Conversations extends Component {
  render() {
    return (
      <div className="container-fluid">
        <Switch>
          {!(this.props.filter || this.props.conversationId) && <Redirect exact from={`${this.props.match.path}`} to={`${this.props.match.path}/mine`} />}
          <Route exact path={`${this.props.match.path}/mine`} render={(routeProps) => (
            <ConversationOverview {...routeProps} filter="mine" />
           )}/>
          <Route exact path={`${this.props.match.path}/open`} render={(routeProps) => (
            <ConversationOverview {...routeProps} filter="open" />
           )}/>
          <Route exact path={`${this.props.match.path}/ongoing`} render={(routeProps) => (
            <ConversationOverview {...routeProps} filter="ongoing" />
           )}/>
          <Route exact path={`${this.props.match.path}/archived`} render={(routeProps) => (
            <ConversationOverview {...routeProps} filter="archived" />
           )}/>
          <Route exact path={`${this.props.match.path}/:cid`} render={(routeProps) => (
            <ConversationOverview {...routeProps} conversationId={routeProps.match.params.cid} />
           )}/>
        </Switch>
      </div>
    );
  }
}

export default Conversations;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Conversations/index.js